const ROUTER = {
  order: '/order-history',
  orderDetail: (id: string) => `/order-history/${id}`,
  depositInfo: (id: string) => `/order-history/info/${id}`,
  address: '/address',
  restaurants: (category: string) => {
    let _category = category;
    if (!_category) {
      return '/all/restaurants';
    }

    if (_category.includes('/')) {
      _category = _category.replace('/', '-');
    }
    return `/restaurants/${_category}`;
  },
};

export default ROUTER;
